import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function Russian() {
    useEffect(() => {
        document.title = 'КьюАй - Русский язык';
    }, [])

    return <>
        <div>
            Наши опытные преподаватели помогут устранить проблемы с языком, которые могут возникнуть в школе. Мы
            работаем над улучшением грамотности, развиваем орфографическую зоркость, тренируем писать диктанты и
            разбираем тесты. Наши воспитанники находятся под постоянным контролем учителей: получают домашние
            задания, которое регулярно проверяется и оценивается. Что позволяет отследить усвоение изученного
            материала. Темы объясняются доступным для ребят языком, что способствуют быстрому усвоению
            материала.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Закрепление навыков грамотной письменной и устной русской речи;</li>
                    <li>Систематизирование и углубление знаний правил русского языка;</li>
                    <li>Развитие орфографической зоркости;</li>
                    <li>Подготовка к написанию сочинений и диктантов;</li>
                    <li>Развитие ораторских способностей.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-rja"></div>
            </div>
        </div>
        <div>
            Школа КьюАй гордиться отличными результатами в обучении Русскому языку. Программа построена таким
            образом, чтобы мотивировать школьника на регулярные занятия без пропусков, что позволяет
            преподавателю эффективно доносить знания. Ученик систематически выполняет домашние задания, что
            обеспечивает постоянный прогресс в освоении языка. Воспитанник замотивирован в достижении своей
            цели, благодаря атмосфере продуктивности, созданной нашими педагогами.
        </div>
        <div>
            Родители, у ваших детей есть великолепная возможность изучать русский язык на высоком уровне с
            помощью курса Русский язык от детского центра развития КьюАй. Этот курс предлагает удобный и
            интерактивный способ обучения, который поможет развить у ребенка отличные навыки чтения, письма и
            речи. Не упустите возможность дать вашему ребенку лучшее! Запишитесь на курс Русский язык прямо
            сейчас!
        </div>
    </>
}